<template>
  <tr>
    <td colspan="4">
      <div class="c-product-variants-table__teaser">
        <button
          class="btn btn-outline-primary c-product-variants-table__teaser--button bg-white"
          @click="showHiddenVariants"
        >
          <i class="far fa-arrow-down mr-2"></i>
          <span>
            {{
              getProductPageTranslations[
                'ProductDetail.VariantsTable.TeaserButton.ShowAll'
              ]
            }}
            {{ productCount }}
            {{
              getProductPageTranslations[
                'ProductDetail.VariantsTable.TeaserButton.Products'
              ]
            }}
          </span>
        </button>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  props: {
    productCount: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapState(['culture']),
    ...mapGetters('translations', ['getProductPageTranslations'])
  },
  methods: {
    showHiddenVariants() {
      this.$emit('showHiddenVariants');
    }
  }
};
</script>

<style lang="scss" scoped>
.c-product-variants-table {
  &__teaser {
    max-width: 100vw;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0) 100%
    );

    display: flex;
    align-items: flex-end;
    justify-content: center;
    pointer-events: none;

    &--button {
      pointer-events: auto;
    }
  }
}
</style>
